/* Fox Rings — page section behaviour.
   Every widget is instance-scoped so a section can be added to a page more than
   once, and every hook is defensive so a merchant who deletes all the blocks in
   the theme editor never gets a console error. Copy is read from the DOM, so
   editing text in the theme editor is all that is ever needed. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  function each(list, fn) { Array.prototype.forEach.call(list || [], fn); }
  function all(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------ *
   * 1. Ring explorer — hover / tap a marker to reveal its label.
   *    Title + body come from data-title / data-body on each marker.
   * ------------------------------------------------------------------ */
  function ringExplorer(root) {
    if (root.dataset.fxOn) return; root.dataset.fxOn = '1';
    var stage = root.querySelector('.fx3d__stage');
    var rig = root.querySelector('.fx3d__rig');
    var card = root.querySelector('.fx3d__card');
    if (!stage || !rig || !card) return;

    var T = card.querySelector('b');
    var B = card.querySelector('span');
    var hint = root.querySelector('.fx3d__hint');
    var listEl = root.querySelector('.fx3d__list');
    var hots = all(rig, '.fx3d__hot');
    var rows = listEl ? all(listEl, 'button') : [];
    var active = null;

    if (!hots.length) return;

    /* group id -> [title, body], taken from the first marker in the group */
    var copy = {};
    each(hots, function (h) {
      var g = h.getAttribute('data-g') || '';
      if (!copy[g]) copy[g] = [h.getAttribute('data-title') || '', h.getAttribute('data-body') || ''];
    });

    function place(anchor) {
      var sr = stage.getBoundingClientRect();
      var hr = anchor.getBoundingClientRect();
      var cr = card.getBoundingClientRect();
      var cx = hr.left + hr.width / 2 - sr.left;
      var cy = hr.top + hr.height / 2 - sr.top;
      var cw = cr.width || 220, ch = cr.height || 110, half = cw / 2, pad = 8;
      var clamped = Math.max(half + pad, Math.min(sr.width - half - pad, cx));
      var below = (cy - ch - 16) < 0;
      card.classList.toggle('below', below);
      var top = below ? Math.min(cy, sr.height - ch - pad) : Math.max(cy, ch + 16);
      card.style.left = clamped + 'px';
      card.style.top = top + 'px';
      card.style.setProperty('--tail', (50 + (cx - clamped) / (half * 2) * 100) + '%');
    }

    function show(g, anchor) {
      if (g === active && anchor) { place(anchor); return; }
      active = g;
      each(hots, function (h) { h.classList.toggle('on', h.getAttribute('data-g') === g); });
      each(rows, function (r) { r.classList.toggle('on', r.getAttribute('data-g') === g); });
      if (!g || !copy[g]) {
        card.classList.remove('show');
        rig.classList.remove('dim');
        return;
      }
      var mem = hots.filter(function (h) { return h.getAttribute('data-g') === g; });
      var a = anchor || mem[Math.floor(mem.length / 2)];
      if (!a) return;
      if (T) T.textContent = copy[g][0];
      if (B) B.textContent = copy[g][1];
      card.classList.add('show');
      rig.classList.add('dim');
      place(a);
      if (hint) hint.classList.add('gone');
    }

    function bind(el) {
      var g = el.getAttribute('data-g');
      var isHot = el.classList.contains('fx3d__hot');
      el.addEventListener('mouseenter', function () { show(g, isHot ? el : null); });
      el.addEventListener('focus', function () { show(g, isHot ? el : null); });
      el.addEventListener('click', function (e) {
        e.preventDefault();
        show(active === g ? null : g, isHot ? el : null);
      });
    }
    each(hots, bind);
    each(rows, bind);

    stage.addEventListener('mouseleave', function () { show(null); });
    if (listEl) listEl.addEventListener('mouseleave', function () { show(null); });
    window.addEventListener('resize', function () { if (active) show(active); });
  }

  /* ------------------------------------------------------------------ *
   * 2. Before / after compare slider
   * ------------------------------------------------------------------ */
  function reveal(rv) {
    if (rv.dataset.fxOn) return; rv.dataset.fxOn = '1';
    var rng = rv.querySelector('.pr-reveal__rng');
    var top = rv.querySelector('.pr-reveal__top');
    if (!rng || !top) return;
    var img = top.querySelector('img');

    function set(v) {
      rv.style.setProperty('--p', v + '%');
      if (img) { img.style.width = rv.clientWidth + 'px'; img.style.maxWidth = 'none'; }
    }
    rng.addEventListener('input', function () { set(this.value); });
    window.addEventListener('resize', function () { set(rng.value); });
    set(rng.value);
  }

  /* ------------------------------------------------------------------ *
   * 3. Full-width slide carousel (one card at a time)
   * ------------------------------------------------------------------ */
  function slideCarousel(c) {
    if (c.dataset.fxOn) return; c.dataset.fxOn = '1';
    var track = c.querySelector('.pr-car__track');
    if (!track) return;
    var n = track.children.length;
    if (!n) return;
    var dots = all(c, '.pr-car__dots button');
    var prev = c.querySelector('.pr-car__nav--p');
    var next = c.querySelector('.pr-car__nav--n');
    var idx = 0;

    function go(i) {
      idx = (i % n + n) % n;
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      each(dots, function (d, k) { d.classList.toggle('on', k === idx); });
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    each(dots, function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-i'), 10) || 0); });
    });

    var x0 = null;
    c.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    c.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    go(0);
  }

  /* ------------------------------------------------------------------ *
   * 4. Multi-up auto-advancing carousel.
   *    data-per   = cards visible on desktop (2, 3, 4 or 5)
   *    data-speed = seconds per step, 0 = no autoplay
   * ------------------------------------------------------------------ */
  function multiCarousel(c) {
    if (c.dataset.fxOn) return; c.dataset.fxOn = '1';
    var tr = c.querySelector('.hf-car__track');
    if (!tr) return;
    var sh = Array.prototype.slice.call(tr.children);
    var n = sh.length;
    if (!n) return;
    var dots = all(c, '.hf-car__dots button');
    var prev = c.querySelector('.hf-car__nav--p');
    var next = c.querySelector('.hf-car__nav--n');
    var wide = parseInt(c.getAttribute('data-per'), 10) || 4;
    var secs = parseFloat(c.getAttribute('data-speed'));
    if (isNaN(secs)) secs = 2;
    var i = 0, timer = null;

    function per() {
      if (window.innerWidth <= 600) return 1;
      if (window.innerWidth <= 980) return Math.min(2, wide);
      return wide;
    }
    function max() { return Math.max(0, n - per()); }

    function go(k) {
      var m = max();
      i = k > m ? 0 : (k < 0 ? m : k);
      var step = sh[0].getBoundingClientRect().width + 18;
      tr.style.transform = 'translateX(' + (-i * step) + 'px)';
      each(dots, function (d, x) {
        d.classList.toggle('on', x === i);
        d.hidden = x > m;
      });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (reduce || secs <= 0 || max() === 0) return;
      timer = setInterval(function () { go(i + 1); }, secs * 1000);
    }

    if (prev) prev.addEventListener('click', function () { go(i - 1); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1); play(); });
    each(dots, function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-i'), 10) || 0); play(); });
    });
    c.addEventListener('mouseenter', stop);
    c.addEventListener('mouseleave', play);
    c.addEventListener('focusin', stop);
    c.addEventListener('focusout', play);
    window.addEventListener('resize', function () { go(Math.min(i, max())); });

    go(0);
    play();
  }

  /* ------------------------------------------------------------------ *
   * 5. Quote spotlight — dots switch between quotes
   * ------------------------------------------------------------------ */
  function quoteSpotlight(q) {
    if (q.dataset.fxOn) return; q.dataset.fxOn = '1';
    var slides = all(q, '.qslide');
    var dots = all(q, '.dots i');
    if (slides.length < 2) return;

    function go(k) {
      each(slides, function (s, x) { s.classList.toggle('on', x === k); });
      each(dots, function (d, x) { d.classList.toggle('on', x === k); });
    }
    var at = 0;
    each(dots, function (d, x) {
      d.setAttribute('role', 'button');
      d.setAttribute('tabindex', '0');
      d.addEventListener('click', function () { at = x; go(at); hold(); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); at = x; go(at); hold(); }
      });
    });
    go(0);

    /* Autoplay. Off unless a speed is set, paused on hover and while the tab
       is hidden, and skipped entirely for anyone who has asked for reduced
       motion — a quote that moves on its own is exactly what that setting is
       meant to stop. */
    var every = parseInt(q.getAttribute('data-auto'), 10);
    if (!every || every < 1) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var timer = null;
    function tick() { at = (at + 1) % slides.length; go(at); }
    function play() { stop(); timer = setInterval(tick, every * 1000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function hold() { stop(); play(); }

    q.addEventListener('mouseenter', stop);
    q.addEventListener('mouseleave', play);
    q.addEventListener('focusin', stop);
    q.addEventListener('focusout', play);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { play(); }
    });
    play();
  }

  /* ------------------------------------------------------------------ *
   * Boot. Re-run on Shopify theme-editor events so a merchant sees the
   * widget work the instant they add or edit a section.
   * ------------------------------------------------------------------ */
  var WIDGETS = [
    ['.fx3d', ringExplorer],
    ['.pr-reveal', reveal],
    ['.pr-car', slideCarousel],
    ['.hf-car', multiCarousel],
    ['.quotes', quoteSpotlight]
  ];

  function init(scope) {
    var root = scope || document;
    each(WIDGETS, function (w) {
      each(all(root, w[0]), w[1]);
      if (root !== document && root.matches && root.matches(w[0])) w[1](root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
